// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-o_fs","advertDetailParameterList__header":"c-o_ft","advertDetailParameterList__list":"c-o_fu"};